<template>
  <validation-provider
    class="sm:col-span-2 flex"
    tag="div"
    name="contact_consent"
    mode="passive"
    v-slot="{ errors }"
    v-if="hasContactConsent"
  >
    <form-checkbox
      class="items-center"
      size="21.5"
      v-model="internalValue"
      data-testid="accept-contact-consent"
      @change="onInput"
    ></form-checkbox>
    <div
      class="text-base leading-tight font-normal inline-block items-center mt-1"
    >
      <span>I’d like to hear about new offers or services and accept the </span>
      <div class="pr-1" style="display: inline-block">
        <span
          @click="showContactConsentOverlay = true"
          class="cursor-pointer underline text-left"
          :style="`color: ${linkColor}`"
          data-testid="show-contact-consent"
        >
          Contact Consent
        </span>
        <overlay-policy
          v-if="showContactConsentOverlay"
          :policyUrl="contactConsentUrl"
          @close="onClose"
        />
      </div>
    </div>
    <form-alert-msg slot="error" v-if="errors[0]">{{
      errors[0]
    }}</form-alert-msg>
  </validation-provider>
</template>

<script>
import { FormAlertMsg, FormCheckbox } from "@/components/Form/";
import { ValidationProvider } from "vee-validate";
import OverlayPolicy from "@/components/Overlay/OverlayPolicy";

export default {
  components: {
    ValidationProvider,
    FormAlertMsg,
    FormCheckbox,
    OverlayPolicy,
  },
  props: ["checked"],
  data() {
    return {
      internalValue: false,
      showContactConsentOverlay: false,
    };
  },
  computed: {
    linkColor() {
      return this.$store.state.config?.colors?.primaryOptionColor || "#51B44F";
    },
    hasContactConsent() {
      return this.$store.getters.location?.settings?.has_contact_consent;
    },
    contactConsentUrl() {
      return this.$store.getters.location?.settings?.contact_consent_url || "";
    },
  },
  watch: {
    checked: {
      handler(val) {
        this.internalValue = val;
      },
      immediate: true,
    },
  },
  methods: {
    onInput(val) {
      this.$emit("input:field", val);
      if (val) {
        // Trigger: When a user clicks on the check box consenting to be contacted.
        this.$gtm.trackEvent({
          event: "form_step",
          step_name: "Accept Contact Consent", // The name of the step the user is at
          step_number: "14", // The number of the step the user is at
        });
      } else {
        // Trigger: When a user clicks on the check box consenting to be contacted.
        this.$gtm.trackEvent({
          event: "form_step",
          step_name: "Reject Contact Consent", // The name of the step the user is at
          step_number: "14", // The number of the step the user is at
        });
      }
    },
    handleClick() {
      this.showContactConsentOverlay = true;
      this.$telemetry.trackEvent({
        name: "patient_details.contact_consent.display",
      });
      this.$gtm.trackEvent({
        event: "contact_consent_opened",
      });
    },
    onClose() {
      this.showContactConsentOverlay = false;
      this.$telemetry.trackEvent({
        name: "patient_details.contact_consent.close",
      });
      this.$gtm.trackEvent({
        event: "contact_consent_closed",
      });
    },
  },
};
</script>
